import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie"; // npm install js-cookie

export default function Navbar() {
  const navigate = useNavigate();

  const handleLogout = () => {
    // Clear relevant auth cookies (adjust if you use specific names)
    Cookies.remove("token"); // or whatever cookie you're using
    Cookies.remove("user");

    // Redirect to refund login
    navigate("/refund-login");
  };

  return (
    <nav className="bg-orange-600 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <div className="flex items-center">
          <img
            src="https://aicee.in/static/media/logo1.bdff491eff12e960f90c.png"
            alt="AICEE Logo"
            className="h-10 w-auto mr-3"
          />
          <span className="text-white text-lg sm:text-xl font-semibold tracking-wide">
            AICEE 2026 Refund Portal
          </span>
        </div>

        <button
          onClick={handleLogout}
          className="bg-white text-orange-600 font-medium px-4 py-1.5 rounded hover:bg-gray-100 transition text-sm"
        >
          Logout
        </button>
      </div>
    </nav>
  );
}
